import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/AidenIFrame/AidenIFrame.container"
    ).then((module) => ({
        default: module.AidenIFrameContainer
    }))
);
